import { Text, Button, Flex } from '@chakra-ui/react';
import UserService from 'api/services/UserService';
import InputMy from 'components/InputMy';
import { useFormik } from 'formik';
import _ from 'lodash';
import showMessage from 'providers/NoticeProvider/showMessage';
import { useState } from 'react';
import { changePasswordValidationSchema } from 'validations';

const initialValues = { password: '', newPassword: '' };

const ChangePassword = () => {
    const [loading, setLoading] = useState(false);

    const formik = useFormik({
        initialValues,
        validationSchema: changePasswordValidationSchema,
        onSubmit: async params => {
            try {
                setLoading(true);
                await UserService.updatePassword(params)
                    .then(response => {
                        console.log(response);
                        formik.resetForm();
                        showMessage('Your data has been successfully saved.');
                    })
                    .finally(() => {
                        setLoading(false);
                    });
            } catch (e) {
                return false;
            }
        },
    });

    const disabled = _.isEqual(initialValues, formik.values);

    return (
        <div>
            <Text color="gray.900" fontSize="24px" fontWeight={700} lineHeight={1} letterSpacing="-0.48px" mb="16px">
                Password change
            </Text>
            <Text color="gray.500" fontSize="14px" fontWeight={500} mb="32px">
                A password must contain a minimum of 12 characters, one lower case letter and one number.
            </Text>
            <Flex flexWrap="wrap" rowGap="24px" columnGap="16px" maxWidth={{ sm: '620px', lg: '300px' }}>
                <InputMy
                    name="password"
                    label="Current Password"
                    type="password"
                    placeholder="Current Password"
                    value={formik.values.password}
                    onChange={formik.handleChange}
                    error={formik.touched.password && Boolean(formik.errors.password)}
                    helperText={formik.touched.password && formik.errors.password}
                    onBlur={formik.handleBlur}
                    autoComplete="new-password"
                />
                <InputMy
                    name="newPassword"
                    label="New Password"
                    type="password"
                    placeholder="New Password"
                    value={formik.values.newPassword}
                    onChange={formik.handleChange}
                    error={formik.touched.newPassword && Boolean(formik.errors.newPassword)}
                    helperText={formik.touched.newPassword && formik.errors.newPassword}
                    onBlur={formik.handleBlur}
                    autoComplete="new-password"
                />

                <Flex flex="1 0 100%" gap="8px">
                    <Button
                        fontSize="md"
                        variant="brand"
                        fontWeight="600"
                        h="48px"
                        padding="0 24px"
                        onClick={() => formik.submitForm()}
                        isDisabled={disabled}
                        isLoading={loading}
                    >
                        Change password
                    </Button>
                    <Button
                        fontSize="md"
                        variant="outline"
                        fontWeight="600"
                        h="48px"
                        padding="0 24px"
                        onClick={() => formik.resetForm()}
                        isDisabled={disabled || loading}
                    >
                        Cancel
                    </Button>
                </Flex>
            </Flex>
        </div>
    );
};

export default ChangePassword;
